import Vue from 'vue'
import Router from 'vue-router'

//车辆 管理///////////////////////////////
const car_base = () => import("@/components/ys_car/car_base2"); //汽车基础信息
const carInsurance = () => import("@/components/ys_car/car_Insurance"); //汽车保险登记信息
const carMaintenance = () => import("@/components/ys_car/car_Maintenance"); //汽车保养登记信息
const carCheck = () => import("@/components/ys_car/car_Check"); //汽车年审登记信息
const carRepair = () => import("@/components/ys_car/car_Repair"); //汽车维修登记信息
const carViolation = () => import("@/components/ys_car/car_Violation"); //汽车违章登记信息
const carViolationOver = () => import("@/components/ys_car/car_Violation_over"); //汽车违章登记审核信息
const carAccident = () => import("@/components/ys_car/car_Accident"); //汽车肇事登记信息
const transbad = () => import("@/components/ys_car/trans_bad"); //违章罚款登记信息

const teamname = () => import("@/components/ys_car/team_name");
const teamuser = () => import("@/components/ys_car/team_user");
const teamcar = () => import("@/components/ys_car/team_car");




Vue.use(Router)

export default[
	{
		name: "carbase",
		path: "/car_base",
		component: car_base,
		meta: {
			requiresAuth: false,
			keepAlive: false, // 不需要被缓存
			title: "汽车基本信息"
		}
	},
	{
		name: "carInsurance",
		path: "/carInsurance",
		component: carInsurance,
		meta: {
			requiresAuth: false,
			keepAlive: false, // 不需要被缓存
			title: "汽车保险登记信息"
		}
	},
	{
		name: "carMaintenance",
		path: "/carMaintenance",
		component: carMaintenance,
		meta: {
			requiresAuth: false,
			keepAlive: false, // 不需要被缓存
			title: "汽车保养登记信息"
		}
	},
	{
		name: "carCheck",
		path: "/carCheck",
		component: carCheck,
		meta: {
			requiresAuth: true,
			keepAlive: false, // 不需要被缓存
			title: "汽车审车登记信息"
		}
	},
	{
		name: "carRepair",
		path: "/carRepair",
		component: carRepair,
		meta: {
			requiresAuth: true,
			keepAlive: false, // 不需要被缓存
			title: "汽车维修登记信息"
		}
	},
	{
		name: "carViolation",
		path: "/carViolation",
		component: carViolation,
		meta: {
			requiresAuth: true,
			keepAlive: false, // 不需要被缓存
			title: "汽车违章登记信息"
		}
	},
	{
		name: "carViolationOver",
		path: "/carViolationOver",
		component: carViolationOver,
		meta: {
			requiresAuth: true,
			keepAlive: false, // 不需要被缓存
			title: "汽车违章登记审核"
		}
	},
	{
		name: "carAccident",
		path: "/carAccident",
		component: carAccident,
		meta: {
			requiresAuth: true,
			keepAlive: false, // 不需要被缓存
			title: "汽车肇事登记信息"
		}
	},
	{
		name: "teamname",
		path: "/teamname",
		component: teamname,
		meta: {
			requiresAuth: true,
			keepAlive: false, // 不需要被缓存
			title: "车队名称"
		}
	},
	{
		name: "teamuser",
		path: "/teamuser",
		component: teamuser,
		meta: {
			requiresAuth: true,
			keepAlive: false, // 不需要被缓存
			title: "车队人员名称"
		}
	},
	{
		name: "teamcar",
		path: "/teamcar",
		component: teamcar,
		meta: {
			requiresAuth: true,
			keepAlive: false, // 不需要被缓存
			title: "车队车辆归属"
		}
	}
]